import styled from 'styled-components';
import Dialog from 'components/shared/Dialog';

export const CloseWrapper = styled.button`
  position: absolute;
  width: 16px;
  height: 16px;
  top: 16px;
  right: 16px;
  transform: scale(1.5);
  cursor: pointer;
  color: ${({ theme }) => theme.colors.default};
  background: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalHeader = styled(Dialog.Title)`
  font-family: ${({ theme }) => theme.base.fontHeader};
  font-size: 24px;
  font-weight: 600;
  padding-top: 12px;
  padding-bottom: 8px;
`;

export const ModalDescription = styled(Dialog.Description).withConfig({
  attrs: {
    as: 'div',
  },
})`
  font-family: ${({ theme }) => theme.base.fontBody};
  font-size: 16px;
  font-weight: 400;
  margin-top: -18px;
  padding-bottom: 8px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 0 8px;

  button:not(:last-of-type) {
    margin-right: 8px;
  }
`;
